// extracted by mini-css-extract-plugin
export default {"ModalForm":"ModalForm_ModalForm__+9E28","Form":"ModalForm_Form__LUzQe"};